module.exports = __webpack_public_path__ + "img/8.a1686162.png";